import LegalShell, { LegalSection } from "../components/LegalShell";

export default function TermsWebsiteNotice() {
  return (
    <LegalShell
      title="Terms & Website Notice"
      subtitle="Effective September 1, 2026"
      description="Terms and conditions governing the use of the Mitaja Corporation website."
      lastUpdated="September 1, 2026"
      documentLabel="Mitaja Corporation — Terms & Website Notice"
    >
      <LegalSection title="General Informational Purpose">
        <p>
          The content on this website is provided for general informational purposes only. It describes Mitaja Corporation's
          services, capabilities, and business for the benefit of prospective partners, customers, and employees. You may use
          this website only for lawful, informational purposes and in accordance with these terms.
        </p>
      </LegalSection>

      <LegalSection title="No Proposal, Offer, Warranty, Contract, or Legal Advice">
        <p>
          Nothing on this website constitutes a proposal, offer, bid, quote, warranty, contract commitment, or solicitation,
          nor does it constitute legal, financial, or professional advice. Capability, certification, and contract information
          on this website is provided for general awareness and does not create any binding commitment by Mitaja. You should
          not rely on website content in making decisions without independently verifying the relevant information and
          consulting appropriate professionals.
        </p>
      </LegalSection>

      <LegalSection title="Verification of Contract, Certification, and Past-Performance Information">
        <p>
          Contract identifiers, certification numbers, vehicle information, and past-performance descriptions are provided for
          general reference. These details should be independently verified against the relevant agency, certifying body, or
          contract vehicle before being relied upon for a specific procurement or decision. Mitaja strives for accuracy but
          makes no guarantee that such information is current or complete for any particular procurement.
        </p>
      </LegalSection>

      <LegalSection title="References Do Not Imply Endorsement">
        <p>
          References to customers, agencies, partners, or programs are provided to describe the general scope and nature of
          Mitaja's work. Such references do not imply endorsement by, or affiliation with, any named or unnamed agency,
          organization, or individual. Agency names are used for descriptive purposes only.
        </p>
      </LegalSection>

      <LegalSection title="Attribution of Subcontract and Partner-Supported Work">
        <p>
          Where Mitaja has performed work as a subcontractor or through partner-supported or teaming relationships, this
          website clearly attributes that work accordingly. End-client relationships may remain attributable to the applicable
          prime contractor, partner, or intermediary, and Mitaja does not claim direct-award relationships that do not exist.
        </p>
      </LegalSection>

      <LegalSection title="Intellectual Property and Acceptable Use">
        <p>
          The content, text, graphics, logos, and other materials on this website are owned by or licensed to Mitaja and are
          protected by applicable intellectual-property laws. You may not reproduce, distribute, modify, or create derivative
          works from this content without our prior written permission, except for reasonable personal or internal business
          reference. You agree not to use this website in any way that could damage, disable, overload, or impair the site or
          interfere with any other party's use of it.
        </p>
      </LegalSection>

      <LegalSection title="External-Link Disclaimer">
        <p>
          This website may contain links to external websites operated by third parties. These links are provided for your
          convenience. Mitaja does not control and is not responsible for the content, products, services, or privacy practices
          of any external website. Accessing any external site is at your own risk.
        </p>
      </LegalSection>

      <LegalSection title="Limitation of Liability">
        <p>
          To the fullest extent permitted by law, Mitaja Corporation and its officers, employees, and agents shall not be
          liable for any direct, indirect, incidental, special, consequential, or punitive damages arising out of or related to
          your access to or use of this website, any reliance on its content, or any external site linked from it, even if
          advised of the possibility of such damages. This website and its content are provided "as is" without warranties of
          any kind, express or implied.
        </p>
      </LegalSection>

      <LegalSection title="Governing Law">
        <p>
          [Placeholder for review: These terms shall be governed by and construed in accordance with the laws of the State of
          Maryland, without regard to its conflict-of-law provisions, and any disputes shall be subject to the exclusive
          jurisdiction of the appropriate state or federal courts in Maryland.] This governing-law provision is a placeholder
          and must be reviewed and finalized by qualified legal counsel before publication.
        </p>
      </LegalSection>

      <LegalSection title="Changes to These Terms">
        <p>
          We may update these Terms & Website Notice from time to time and will revise the "Last updated" date accordingly.
          Continued use of this website after changes are posted constitutes acceptance of the updated terms.
        </p>
      </LegalSection>
    </LegalShell>
  );
}